// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-header {\n  padding: 0 0 10px; }\n\n.message-content {\n  background-color: transparent;\n  box-shadow: none;\n  border: 0; }\n\n.message-close {\n  font-size: 60px;\n  font-weight: 400;\n  opacity: 1;\n  color: white; }\n\n.message-body {\n  background-color: white; }\n\n.message-line {\n  border-top: 1px dashed #e1e1e1;\n  margin-left: -15px;\n  margin-right: -15px; }\n\n.message-textarea {\n  resize: none;\n  border: 0;\n  box-shadow: none;\n  font-size: 20px; }\n  @media only screen and (max-width: 767px) {\n    .message-textarea {\n      height: 250px; } }\n\n.message-submit {\n  width: 100%;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1;\n  padding: 12px 0; }\n\n@media (min-width: 768px) {\n  .message-dialog {\n    width: 530px; } }\n", ""]);
// Exports
module.exports = exports;


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/member/shared/message-modal/message-modal.component.scss
// module id = 984
// module chunks = 0